<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="AI豆账户管理"
      title="AI豆账户管理"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"

      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />

    <!-- 充值/扣除对话框 -->
    <HpsfirProForm
      ref="changeFormRef"
      :is-dialog="true"
      title="充值/扣除AI豆"
      :items="changeFormItems"
      @ok="handleChangeSubmit"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '../../../hooks/useApi';
import {
  ElMessage,
  FormInstance,
} from 'element-plus';
import { ref, reactive, onMounted } from 'vue';
import dayjs from 'dayjs';
import { AIBEANCHANGESOURCEE, AiBeanAdminVo } from '../../../api/api';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

// 表格列
const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));

// 表格引用
const tableRef = ref<any>();

// 初始化列配置
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'phone',
      label: '手机号',
      type: 'string',
      isCondition: true,
      rule: [
        { required: true, message: '请输入手机号' },
        { pattern: /^1[3-9]\d{9}$/u, message: '请输入正确的手机号格式' },
      ],
      width: 140,
    },
    {
      name: 'beanCount',
      label: 'AI豆数量',
      type: 'number',
      rule: [{ required: true, message: '请输入AI豆数量' }],
      width: 120,
      hideEdit: true,
      hideCreate: true,

    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideEdit: true,
      hideCreate: true,
      width: 180,

    },
    {
      name: 'updateTime',
      label: '更新时间',
      type: 'string',
      hideEdit: true,
      hideCreate: true,
      width: 180,
    },
  ]);
});

// 添加和查询初始值
const addInitValue = {
  // 默认值
};

const conditionsInitValue = {
  // 搜索条件默认值
};

// 加载状态
const loading = ref(false);

// 充值/扣除相关
const changeSubmitLoading = ref(false);
const changeFormRef = ref<any>();
const changeForm = reactive({
  id: 0,
  phone: '',
  currentBeanCount: 0,
  // 1: 充值, 2: 扣除
  type: 1,
  changeCount: 1,
});

// 充值/扣除表单列定义
const changeFormItems = ref<HpsfirProFormItem[]>([
  {
    name: 'phone',
    label: '手机号',
    type: 'text',
  },
  {
    name: 'currentBeanCount',
    label: '当前AI豆',
    type: 'text',
  },
  {
    name: 'type',
    label: '操作类型',
    type: 'select',
    options: [
      { label: '充值', value: 1 },
      { label: '扣除', value: 2 },
    ],
    rule: [{ required: true, message: '请选择操作类型', trigger: 'change' }],
  },
  {
    name: 'changeCount',
    label: '数量',
    type: 'number',
    min: 1,
    rule: [{ required: true, message: '请输入变更数量', trigger: 'blur' }],
  },
  {
    name: 'changeSource',
    label: '变更原因',
    type: 'text',
    textContent: '管理员调整',

  },
]);

// 充值/扣除操作
const handleChangeBalance = useBaseAsync((row: any) => {
  if (!row.id) {
    ElMessage.warning('无效的记录ID');
    return;
  }

  console.log(row.phone);

  // 更新表单数据
  changeForm.id = row.id;
  changeForm.phone = row.phone || '';
  changeForm.currentBeanCount = row.beanCount || 0;
  // 默认充值
  changeForm.type = 1;
  changeForm.changeCount = 1;


  // 使用showDialog方法显示对话框
  changeFormRef.value?.setFormState({ ...changeForm });
  changeFormRef.value?.showDialog();
});

// 操作栏
const operates: any[] = [
  {
    key: 'changeBalance',
    name: '充值/扣除',
    handler: handleChangeBalance,
    type: 'primary',
  },
];

// 获取数据
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    // 处理过滤条件，移除空值
    const conditions = Object.entries(filter.conditions).reduce((acc, [key, val]) => {
      if (val !== null && val !== undefined && val !== '') {
        acc[key] = val;
      }
      return acc;
    }, {} as Record<string, any>);

    const res = await useApi().aibeanApi.pageAiBeanaibean({
      conditions,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    console.log(res);

    const tableData: HpsfirProTableData = {
      total: res.data?.data?.total || 0,
      data: res.data?.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

// 格式化删除确认信息
const formatDeleteInfo = (row: any) => `确定要删除该AI豆账户吗？手机号: ${row.phone || '未知'}`;

// 添加AI豆账户
const addFun = useBaseAsync(async(data: any) => {
  await useApi().aibeanApi.addAiBeanaibean({
    aiBeanAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

// 更新AI豆账户
const updateFun = useBaseAsync(async(data: any) => {
  await useApi().aibeanApi.updateAiBeanaibean({
    aiBeanAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

// 删除AI豆账户
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().aibeanApi.deleteAiBeanaibean(data.id);
  ElMessage.success('删除成功');
});

// 提交充值/扣除 - 由HpsfirProForm的@ok事件直接调用
const handleChangeSubmit = useBaseAsync(async(formValues: any) => {
  try {
    changeSubmitLoading.value = true;

    // 计算最终变更值
    const finalChangeValue = formValues.type === 1
      ? formValues.changeCount
      : -formValues.changeCount;


    await useApi().aibeanApi.changeAiBeanCountaibean({
      phone: formValues.phone,
      changeCount: finalChangeValue,
      changeSource: AIBEANCHANGESOURCEE.System,
    });

    ElMessage.success('操作成功');

    // 刷新表格
    tableRef.value?.refresh();
  } catch (error) {
    console.error('操作失败:', error);
    ElMessage.error('操作失败');
  } finally {
    changeSubmitLoading.value = false;
  }
});

// 页面初始化
init();
</script>

<style lang="scss" scoped>
.juou-card {
  height: 100%;
}
</style>
